import { GetImageKey, ImageKeyProps } from '../types';
import imagePathKey from './imagePathKey';

const ourAvatarKey: GetImageKey =
  (type: string) =>
  ({ id, src }: ImageKeyProps) =>
    imagePathKey('avatar', type, id, src);

export default ourAvatarKey;